"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertVariants = void 0;
var AlertVariants = {
  Success: 'success',
  Warning: 'warning'
  // Error: 'error' as const
};
exports.AlertVariants = AlertVariants;